import { ComponentProps, ReactNode } from 'react';

import { SelectModal } from '@pukka/ui-components';

interface OutletSelectorV2FooterProps<T>
  extends ComponentProps<Exclude<ComponentProps<typeof SelectModal<T>>['footer'], undefined | ReactNode>> {}

function OutletSelectorV2Footer<T>({ selections, errorMessage }: OutletSelectorV2FooterProps<T>) {
  return (
    <>
      <div className="text-sm">
        <div className="flex items-center text-neutral-400">
          <span>{`Selected: ${selections.size}`}</span>
        </div>
      </div>
      {errorMessage || null}
    </>
  );
}

export { OutletSelectorV2Footer };
